import { inject } from '@angular/core';
import { CanMatchFn, GuardResult } from '@angular/router';
import { AuthStore } from '../auth/store/auth-store';

/**
 * A `canMatch` route guard that delays route matching until the auth state has settled.
 */
export const canMatchWithSettledAuthState: CanMatchFn = async (): Promise<GuardResult> => {
    const authStore: AuthStore = inject(AuthStore);
    await authStore.authStateReady();
    return true;
};